import { render, staticRenderFns } from "./ModalScharffPointPackage.vue?vue&type=template&id=a9fcaf0c&"
import script from "./ModalScharffPointPackage.vue?vue&type=script&lang=js&"
export * from "./ModalScharffPointPackage.vue?vue&type=script&lang=js&"
import style0 from "./ModalScharffPointPackage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports